import { ReactComponent as ArrowDownIcon } from './assets/ArrowDownIcon.svg';
import { ReactComponent as BoostIcon } from './assets/BoostIcon.svg';
import { ReactComponent as BriefIcon } from './assets/BriefIcon.svg';
import { ReactComponent as BubbleText } from './assets/BubbleTextIcon.svg';
import { ReactComponent as CameraIcon } from './assets/CameraIcon.svg';
import { ReactComponent as CheckIcon } from './assets/CheckIcon.svg';
import { ReactComponent as CrossIcon } from './assets/CrossIcon.svg';
import { ReactComponent as DownArrowIcon } from './assets/DownArrowIcon.svg';
import { ReactComponent as DownloadIcon } from './assets/DownloadIcon.svg';
import { ReactComponent as FlashIcon } from './assets/FlashIcon.svg';
import { ReactComponent as GenerateIcon } from './assets/GenerateIcon.svg';
import { ReactComponent as HumaniseIcon } from './assets/HumaniseIcon.svg';
import { ReactComponent as ImgIcon } from './assets/ImgIcon.svg';
import { ReactComponent as IncreaseIcon } from './assets/IncreaseIcon.svg';
import { ReactComponent as InformationIcon } from './assets/InformationIcon.svg';
import { ReactComponent as InstagamIcon } from './assets/InstagramIcon.svg';
import { ReactComponent as LeftArrowRoundedIcon } from './assets/LeftArrowIcon.svg';
import { ReactComponent as LeftArrowSoloIcon } from './assets/LeftArrowSoloIcon.svg';
import { ReactComponent as LinkedinIcon } from './assets/LinkedinIcon.svg';
import { ReactComponent as AudioIcon } from './assets/MicIcon.svg';
import { ReactComponent as MuteIcon } from './assets/MuteIcon.svg'
import { ReactComponent as SourcesIcon } from './assets/NewSourcesIcon.svg';
import { ReactComponent as OfflineIcon } from './assets/OfflineIcon.svg';
import { ReactComponent as PauseIcon } from './assets/PauseIcon.svg';
import { ReactComponent as PhotoIcon } from './assets/PhotoIcon.svg';
import { ReactComponent as PlayIcon } from './assets/PlayIcon.svg';
import { ReactComponent as RedoIcon } from './assets/RedoIcon.svg';
import { ReactComponent as ResizeIcon } from './assets/ResizeIcon.svg';
import { ReactComponent as RetryIcon } from './assets/RetryIcon.svg';
import { ReactComponent as ReverseIcon } from './assets/ReverseIcon.svg';
import { ReactComponent as StarGradientIcon } from './assets/StarGradientIcon.svg';
import { ReactComponent as StarIcon } from './assets/StarIcon.svg';
import { ReactComponent as TrashIcon } from './assets/TrashIcon.svg';
import { ReactComponent as TwitterIcon } from './assets/TwitterIcon.svg';
import { ReactComponent as UpArrowIcon } from './assets/UpArrowIcon.svg';
import { ReactComponent as UploadIcon } from './assets/UploadIcon.svg';
import { ReactComponent as WarningIcon } from './assets/WarningIcon.svg';
import { ReactComponent as YoutubeIcon } from './assets/YoutubeIcon.svg';

const fill = (c) => ({ fill: c });

const icons = {
  CROSS: {
    Icon: CrossIcon,
    iconStyle: fill,
  },
  PLAY: {
    Icon: PlayIcon,
    iconStyle: fill,
  },
  PAUSE: {
    Icon: PauseIcon,
    iconStyle: fill,
  },
  TRASH: {
    Icon: TrashIcon,
    iconStyle: fill,
  },
  REVERSE: {
    Icon: ReverseIcon,
    iconStyle: fill,
  },
  RESIZE: {
    Icon: ResizeIcon,
    iconStyle: fill,
  },
  RETRY: {
    Icon: RetryIcon,
    iconStyle: fill,
  },
  AUDIO: {
    Icon: AudioIcon,
    iconStyle: fill,
  },
  FLASH: {
    Icon: FlashIcon,
    iconStyle: fill,
  },
  DOWNLOAD: {
    Icon: DownloadIcon,
    iconStyle: fill,
  },
  ARROW_UP: {
    Icon: UpArrowIcon,
    iconStyle: fill,
  },
  ARROW_LEFT: {
    Icon: LeftArrowSoloIcon,
    iconStyle: fill,
  },
  ARROW_LEFT_ROUNDED: {
    Icon: LeftArrowRoundedIcon,
    iconStyle: fill,
  },
  ARROW_DOWN: {
    Icon: DownArrowIcon,
    iconStyle: fill,
  },
  CAMERA: {
    Icon: CameraIcon,
    iconStyle: fill,
  },
  PHOTO: {
    Icon: PhotoIcon,
    iconStyle: fill,
  },
  BRIEF: {
    Icon: BriefIcon,
    iconStyle: fill,
  },
  INFORMATION: {
    Icon: InformationIcon,
    iconStyle: fill,
  },
  INSTAGRAM: {
    Icon: InstagamIcon,
    iconStyle: fill,
  },
  LINKEDIN: {
    Icon: LinkedinIcon,
    iconStyle: fill,
  },
  YOUTUBE: {
    Icon: YoutubeIcon,
    iconStyle: fill,
  },
  TWITTER: {
    Icon: TwitterIcon,
    iconStyle: fill,
  },
  STAR: {
    Icon: StarIcon,
    iconStyle: fill,
  },
  STAR_GRADIENT: {
    Icon: StarGradientIcon,
    iconStyle: fill,
  },
  BUBBLE_TEXT: {
    Icon: BubbleText,
    iconStyle: fill,
  },
  BOOST: {
    Icon: BoostIcon,
    iconStyle: fill,
  },
  GENERATE: {
    Icon: GenerateIcon,
    iconStyle: fill,
  },
  HUMANISE: {
    Icon: HumaniseIcon,
    iconStyle: fill,
  },
  INCREASE: {
    Icon: IncreaseIcon,
    iconStyle: fill,
  },
  SOURCES: {
    Icon: SourcesIcon,
    iconStyle: fill,
  },
  ARROWDOWN: {
    Icon: ArrowDownIcon,
    iconStyle: fill,
  },
  WARNING: {
    Icon: WarningIcon,
    iconStyle: (c) => ({
      fill: c,
    }),
  },
  OFFLINE: {
    Icon: OfflineIcon,
    iconStyle: (c) => ({
      fill: c,
    }),
  },
  CHECK: {
    Icon: CheckIcon,
    iconStyle: fill,
  },
  REDO: {
    Icon: RedoIcon,
    iconStyle: fill,
  },
  IMG: {
    Icon: ImgIcon,
    iconStyle: fill,
  },
  UPLOAD: {
    Icon: UploadIcon,
    iconStyle: fill,
  },
  MUTE: {
    Icon: MuteIcon,
    iconStyle: fill,
  },
};

export default icons;
